var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-overlay" }, [
    _c(
      "div",
      {
        staticClass: "in-content del",
        class: { clsng: _vm.Global.tempClosingOverlay },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm.asset
          ? _c("ContentCard", {
              attrs: {
                posterSrc: _vm.asset.poster,
                moneyTag: _vm.Global.plans[_vm.asset.planIndex].name,
                title: _vm.asset.name,
                genreTags: _vm.asset.tags,
                "can-delete": false,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "c-cap txt-ctr" }, [
          _vm._v(
            "You are about to delete this content. This operation is irreversible."
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ctas" }, [
          _c(
            "div",
            {
              staticClass: "btn bck",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_c("span", { staticClass: "txt" }, [_vm._v("Cancel")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn main txt-blk",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.delCard.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "hvr" }),
              _vm._v(" "),
              _c("span", { staticClass: "txt" }, [_vm._v("Yes, delete")]),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("span", { staticClass: "txt-grt" }, [_vm._v("Are you sure?")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }